import { useMemo } from "react";
import { useRefundLineItems } from "./use-refund-line-items-context";
import useLineItemsState from "./use-line-items-state-context";

export const useNotIncludedTaxLineItem = (
  resolution?: "refund" | "discount",
) => {
  const { items } = useRefundLineItems();
  const { lineItemsState } = useLineItemsState();

  return useMemo(
    () =>
      items.reduce((total, li) => {
        // Only calculate taxes for items that are being refunded or discounted with selected quantity > 0
        if (
          (li.resolution !== "refund" && li.resolution !== "discount") ||
          lineItemsState[li.line_item_id].total.selectedQuantity <= 0
        ) {
          return total;
        }
        if (resolution && li.resolution !== resolution) {
          return total;
        }
        const selectedQuantity =
          lineItemsState[li.line_item_id].total.selectedQuantity;

        return li.unitTaxes.reduce((taxTotal, tax) => {
          // `refundable === false` (BBS-342): excluded from the refund by the
          // shop's taxRefundPolicy, so it must not show on the line either.
          // Absent means refundable — every line predating the setting.
          if (tax.includedInPrice || tax.refundable === false) {
            return taxTotal;
          }
          return taxTotal + tax.amount * selectedQuantity;
        }, total);
      }, 0),

    [items, lineItemsState],
  );
};
